import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	label: {
		id: 'issue-table-inline-issue-create.inline-create-from.issue-type-dropdown.label',
		defaultMessage: 'Issue type',
		description: 'Label to be set on the issue type dropdown element',
	},
	labelIssueTerminologyRefreshM4: {
		id: 'issue-table-inline-issue-create.inline-create-from.issue-type-dropdown.label-issue-terminology-refresh-m4',
		defaultMessage: 'Work type',
		description: 'Label to be set on the issue type dropdown element',
	},
});
